import React, { useState } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import OrdersTab from "../../Common/AssignmentsTab";
import Constants from "../../../shared/Constants";

const {
  sorting: { type: sortType }, language, filter: { options: optionsData, components },
} = Constants;

const header = [
  {
    className: "col-3",
    value: language.filter_label_status,
    key: "status",
    icon: sortType.ARROW,
  },
  {
    className: "col",
    value: language.filter_label_customer,
    key: "customer_id",
    icon: sortType.ALPHABETS,
  },
  {
    className: "col",
    value: language.common_dog,
    key: "dog_size",
    icon: sortType.ARROW,
  },
  {
    className: "col-2",
    value: language.label_serviceProvider,
    key: "service_provider_id",
    icon: sortType.ALPHABETS,
  },
  {
    className: "col",
    value: language.header_date_time,
    key: "date_time",
    icon: sortType.ARROW,
  },
  {
    className: "col",
    value: language.header_service,
    key: "service_id",
    icon: sortType.ALPHABETS,
  },
  {
    className: "col",
    value: language.label_room,
    key: "room_id",
    icon: sortType.ALPHABETS,
  },
  {
    className: "col",
    value: language.label_organisation,
    key: "organization",
    icon: sortType.ALPHABETS,
  },
];
const value = [
  {
    className: "col-3",
    key: "status",
    type: "label",
  },
  {
    className: "col",
    key: "customer_id",
    type: "singleUser",
    isDesktop: true,
  },
  {
    className: "col",
    key: "dog_id",
    type: "label",
  },
  {
    className: "col-2",
    key: "service_provider_id",
    type: "singleUser",
  },
  {
    className: "col",
    key: "assignment_start_datetime",
    type: "date",
  },
  {
    className: "col",
    key: "service_id",
    type: "singleUser",
  },
  {
    className: "col",
    key: "room_id",
    type: "singleUser",
  },
  {
    className: "col",
    key: "organization",
    type: "singleUser",
  },
];
const filterDataValues = [
  {
    id: "status",
    component: components.CHECKBOX,
    label: language.filter_label_status,
    values: optionsData.ORDER_STATUS,
    defaultValues: [],
    name: "status",
  },
  {
    id: "service_providers",
    component: components.LETTERSELECT,
    label: language.common_service_provider,
    values: optionsData.ALPHABETS,
    defaultValues: [],
    availableValues: [],
    name: "service_providers",
  },
  {
    id: "services",
    component: components.CHECKBOX,
    label: language.common_service,
    values: [],
    defaultValues: [],
    name: "services",
  },
  {
    id: "date",
    component: components.DATEPICKER,
    label: language.filter_date_diapason,
    fromDate: { defaultDate: "" },
    toDate: { defaultDate: "" },
    name: "date_time",
  },
  {
    id: "organization",
    component: components.LETTERSELECT,
    label: language.filter_label_organization,
    values: optionsData.ALPHABETS,
    defaultValues: [],
    availableValues: [],
    name: "organization",
  },
  {
    id: "customers",
    component: components.LETTERSELECT,
    label: language.filter_label_customer,
    values: optionsData.ALPHABETS,
    defaultValues: [],
    availableValues: [],
    name: "customers",
  },
];

const AssignmentTab = ({ redirectTo, orderData = [] }) => {
  const [loading, setLoading] = useState(false);
  const [meta, setMeta] = useState({
    previous: null,
    current: 0,
    next: 1,
    count: null,
    pageNumber: 1,
    pageSize: 10,
    pages: 1,
  });
  const [filterOptions, setFilterOptions] = useState(filterDataValues);
  const serviceProviderFilters = useSelector((state) => state.FilterReducer.serviceProviderFilters);
  const organizationFilters = useSelector((state) => state.FilterReducer.organizationFilters);
  const allServices = useSelector((state) => state.FilterReducer.allServices);
  const customerFilters = useSelector((state) => state.FilterReducer.customerFilters);

  const fetchFilters = async (options) => {
    setLoading(true);
    const filteredData = options || filterOptions;
    filteredData[1].availableValues = serviceProviderFilters;
    filteredData[2].values = allServices;
    filteredData[4].availableValues = organizationFilters;
    filteredData[5].availableValues = customerFilters;
    setFilterOptions(filteredData);
    setLoading(false);
  };

  const handleGotoPage = (pageNumber) => {
    meta.pageNumber = pageNumber;
    meta.pageSize = 10;
    setMeta(meta);
  };

  return (
    <OrdersTab
      handleGotoPage={handleGotoPage}
      loading={loading}
      fetchData={fetchFilters}
      meta={meta}
      redirectTo={redirectTo}
      filterDataValues={filterDataValues}
      header={header}
      value={value}
      orderData={orderData}
      isCustomers
    />
  );
};
AssignmentTab.propTypes = {
  redirectTo: PropTypes.func,
  orderData: PropTypes.node,
};
AssignmentTab.defaultProps = {
  redirectTo: () => {},
  orderData: [],
};
export default AssignmentTab;
